require('./meteo-icons.font');
